/**
 * QR encoder 薄包裝。
 *
 * 後端 `ticket.qr_payload` 已是 compact JWS（`header.payload.signature` 三段式）；
 * 前端只負責把該字串轉成 QR Code SVG／Canvas。
 *
 * 用 `qrcode.react` 提供 React component（依賴小、無 native binding）。
 */

import { QRCodeSVG } from 'qrcode.react';
import type { JSX } from 'react';

export interface TicketQrProps {
  /** 後端 `qr_payload`（compact JWS） */
  value: string;
  /** px；預設 240 */
  size?: number;
  /** 容錯級別；compact JWS ~ 400+ chars，建議 'M'（15%） */
  level?: 'L' | 'M' | 'Q' | 'H';
}

export function TicketQr({ value, size = 240, level = 'M' }: TicketQrProps): JSX.Element {
  return (
    <QRCodeSVG
      value={value}
      size={size}
      level={level}
      includeMargin
      // 黑底白字（QR scan 標準對比）
      bgColor="#ffffff"
      fgColor="#000000"
    />
  );
}
